import NavBar from '@/components/Nav.vue';

export default {
    name: 'NoticePage',
    components: {
        NavBar,
    },
    data() {
        return {
            selected: 1,
            page: 1,
            more: true,
            loading: false,
            notices: []
        }
    },
    created() {
        this.getDataList();
    },
    mounted() {
        window.addEventListener('scroll', this.scroll, true);
    },
    unmounted() {
        window.removeEventListener('scroll', this.scroll, true);
    },
    methods: {
        getDataList() {
            if (this.more && ! this.loading) {
                this.loading = true;
                this.$http.get('notice', {params: {page: this.page}}).then(result => {
                    this.page++;
                    this.more = result.data.more;
                    this.notices = this.notices.concat(result.data.notices);
                }).finally(() => {
                    this.loading = false;
                })
            }
        },
        changeTab(value) {
            this.selected = value;
            this.loading = false;
            this.page = 1;
            this.more = true;
            this.notices = [];
            this.getDataList();
        },
        scroll() {
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            this.showGoTopBtn = scrollTop > 1000;
            if (document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight <= 100) {
                this.getDataList();
            }
        }
    }
}